import styled, {css} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {breakpoint, colors} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: end;
    flex-wrap: wrap-reverse;
    gap: 0.8rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;

    & > div {
        width: 25%;
        min-width: 250px;
    }

    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: center;
    min-width: 60px;
    gap: 10px;
`;

export const Action = styled.div<{disabled?: boolean}>`
    padding: 5px;
    cursor: pointer;
    ${(props) =>
        props.disabled &&
        css`
            pointer-events: none;
            opacity: 0.3;
        `}
`;

export const CreateUserButton = styled(Button)`
    color: ${colors.brandPrimary};
    text-decoration: none;
    width: auto;
    align-self: flex-start;
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px 10px 0;

    > span {
        padding: 0 20px;
    }
`;

export const ConfirmRemoveFooter = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const CancelConfirmButton = styled(Button)`
    border: 1px solid ${colors.danger} !important;
    color: ${colors.danger};
`;

export const SubmitConfirmButton = styled(Button)`
    background-color: ${colors.danger} !important;
    border: 1px solid ${colors.danger} !important;
`;
